import * as React from 'react';
import {FunctionComponent} from 'react';
import {formatDuration} from '../../../Support/Formatting/formatDuration';
import {formatDistance} from '../../../Support/Formatting/formatDistance';
import {formatAverageSplit} from '../../../Support/Formatting/formatSplit';
import {Speed} from '../../../../Domain/Speed';
import {classNames} from '../../../Support/classNames';
import {GeoTrackInterval, IntervalType} from '../../../../Geo/geoTrackToIntervals';
import {Duration} from '../../../../Domain/Duration';
import {Distance} from '../../../../Domain/Distance';

interface OwnProps {
    interval: GeoTrackInterval;
}

export const OutdoorIntervalTableRow: FunctionComponent<OwnProps> = ({interval}) => {
    const duration: Duration = Duration.fromMilliseconds(
        interval.segments.map((s) => s.duration.milliseconds).reduce((sum, dur) => sum + dur),
    );
    const distance: Distance = Distance.fromMillimeters(
        interval.segments.map((s) => s.distance.millimeters).reduce((sum, dis) => sum + dis),
    );
    return (
        <>
            <tr
                className={classNames('intervaltable__row', {
                    'intervaltable__row--dimmed': interval.type === IntervalType.Rest,
                })}
            >
                <td className="intervaltable__cell">{formatDuration(duration).formatted}</td>
                <td className="intervaltable__cell intervaltable__cell--rightalined">
                    {formatDistance(distance).formatted}
                </td>
                <td className="intervaltable__cell intervaltable__cell--rightalined">
                    {formatAverageSplit(Speed.fromDistanceAndDuration(distance, duration)).formatted}
                </td>
            </tr>
        </>
    );
};
